(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if (!customElements.get('mc-promo-banner')) {
  customElements.define('mc-promo-banner', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.clock = this.querySelector('[data-clock]');
      this.clock.hidden = true;
      this.observer = new ResizeObserver(() => this.syncHeight());
      this.observer.observe(this);
      this.syncHeight();
      if (this.dataset.timerEnabled !== 'true') return;
      this.formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      this.onVisibility = () => this.refresh();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh();
    }
    parisParts(timestamp) {
      return Object.fromEntries(this.formatter.formatToParts(timestamp)
        .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
    }
    nextMidnight(parts) {
      const target = Date.UTC(parts.year, parts.month - 1, parts.day + 1);
      let instant = target;
      for (let attempt = 0; attempt < 3; attempt++) {
        const local = this.parisParts(instant);
        const localAsUtc = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
        const correction = target - localAsUtc;
        instant += correction;
        if (correction === 0) break;
      }
      return instant;
    }
    refresh() {
      clearTimeout(this.timeout);
      this.tick();
      this.timeout = setTimeout(() => this.refresh(), 1000 - (Date.now() % 1000) + 5);
    }
    tick() {
      const now = Date.now();
      const paris = this.parisParts(now);
      const day = `${paris.year}-${paris.month}-${paris.day}`;
      if (this.day !== day) {
        this.day = day;
        this.deadline = this.nextMidnight(paris);
      }
      const atMidnight = paris.hour === 0 && paris.minute === 0 && paris.second === 0;
      const remaining = atMidnight ? 0 : Math.max(0, Math.ceil((this.deadline - now) / 1000));
      const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) {
        this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0');
      }
      this.clock.hidden = false;
    }
    syncHeight() {
      const section = this.closest('.shopify-section');
      document.documentElement.style.setProperty('--announcement-bar-height', `${section ? section.getBoundingClientRect().height : this.getBoundingClientRect().height}px`);
    }
    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.observer?.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
